module.exports = __webpack_public_path__ + "assets/ico-warning.12de9020.svg";